import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTFUNNELHEADERBLOCK_LEGACY_FIELD_ORDER = [
  "text_color",
  "background_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartFunnelHeaderBlockDescriptor: _generatedCartFunnelHeaderBlockDescriptor,
  cartFunnelHeaderBlockBlocDefinition,
  cartFunnelHeaderBlockDashboardLayout,
  cartFunnelHeaderBlockConfig,
  cartFunnelHeaderBlockResolveConfig,
  cartFunnelHeaderBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart funnel / Header",
    componentType: 'CartFunnelHeaderBlockComponent',
    category: 'cart',
    description: "Cart funnel / Header.",
    keywords: [],
    allowed_in: ["CartFunnelPage"],
    sharedFields: {}
  },

  () => ({
    text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-900"},
      options: {
        label: "pages.blocks.cart-funnel-header.text-color.label",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.cart-funnel-header.background-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-funnel-header.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-funnel-header.fieldset.header.label",
            fields: ["text_color", "background_color"],
          },
        ],
      },
    ],
  })
);

export function cartFunnelHeaderBlockDescriptor(): IBlockDescriptor;
export function cartFunnelHeaderBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartFunnelHeaderBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartFunnelHeaderBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartFunnelHeaderBlockDescriptor, cartFunnelHeaderBlockProperties, fieldOrder);
}

export {
  cartFunnelHeaderBlockBlocDefinition,
  cartFunnelHeaderBlockDashboardLayout,
  cartFunnelHeaderBlockProperties,
  cartFunnelHeaderBlockConfig,
  cartFunnelHeaderBlockResolveConfig,
};

export type CartFunnelHeaderBlockConfig = typeof cartFunnelHeaderBlockConfig;
